



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";

const namespace: string = "authentication";

var scroll: any;

@Component({
    directives: {
        abg: {
            inserted: function (element, binding, vnode) {
                var offset = (window.pageYOffset + element.getBoundingClientRect().top) - 50; // 50 is the height of the topbar
                scroll = function () {
                    var doc = document.documentElement;
                    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
                    if (top >= offset) (vnode.context as any).sticky = true;
                    else (vnode.context as any).sticky = false;
                };
                window.addEventListener("scroll", scroll, false);
            },
            unbind: function (element, binding, vnode) {
                window.removeEventListener("scroll", scroll, false);
            }
        }
    }
})
export default class HeaderActionButtons extends Vue {
    @Prop() checkPermition!: PermitionEnum;
    @Prop({ default: false }) preventSave!: boolean;
    @Prop({ default: false }) preventBack!: boolean;
    @Getter("getCurrentUser", { namespace }) getCurrentUser: any;

    // local
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    editorStatus = false;

    get isAdmin() : boolean {
        return this.havePermition(this.getCurrentUser.permissions,
            this.permitionEnum[this.permitionEnum.AdminPrivilege]);
    }

    sticky = false;

    save() {
        if (!this.isAdmin) this.$emit("save", true);
        else this.$emit("save", false);
    }

    saveAndBack() {
        this.$emit("save", true);
    }

    back() {
        this.$emit("back");
    }

    // header component is detroyed and rebuilt in every page load
    // so watchers are unless in this case
    mounted() {
        this.editorStatus = this.$route.name === "editorupdatechannel";
    }

    get showSaveButton(): boolean {
        return this.checkPermition !== null && this.checkPermition !== undefined
            ? this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.checkPermition]) : true;
    }
}
